import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../UserContext";
import { SampleDataTesting } from "../../SampleDataTesting";
import { AnimatePresence, motion } from "framer-motion";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { Tooltip } from "react-tippy";

export default function LeftHome({
  // openMenu,
  toggleDropdown,
  subToggleDropdown,
  open,
  // selectedHighlight,

  // page heading
  // elementsContent,
  // highlightElement,
  // activeElement,
  headings,
  // dropDown create
  SidebarMenu,

  leftBarHide,
  collapseLeftBarFun,
  iconContentTitle,
}) {
  const {
    darkTheme,
    allPosts,
    openMenu,
    setOpenMenu,
    selectedHighlight,
    isFooterVisible,
  } = useContext(UserContext);

  //   ANIMATION
  const dropdownVariants = {
    closed: {
      opacity: 0,
      height: 0,
      transition: {
        duration: 0.3,
        // ease: "easeInOut",
        ease: [0.42, 0, 0.58, 1],
      },
    },
    open: {
      opacity: 1,
      height: "auto",
      transition: {
        duration: 0.5,
        // ease: "easeInOut",
        ease: [0.42, 0, 0.58, 1],
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    closed: {
      opacity: 0,
      y: -20,
    },
    open: { opacity: 1, y: 0 },
  };

  const [collapsedCategories, setCollapsedCategories] = useState({});
  const toggleCategory = (name) =>
    setCollapsedCategories((c) => ({ ...c, [name]: !c[name] }));

  // In-page outline (this article's own headings) nested under the active
  // sidebar item -- expanded by default, collapses back open on navigation
  // to a new article.
  const [isOutlineOpen, setIsOutlineOpen] = useState(true);
  useEffect(() => {
    setIsOutlineOpen(true);
  }, [selectedHighlight]);

  const GetInitialDropdownFunc = async () => {
    const mainArr = await allPosts.flatMap((menu) => menu.posts);
    const findId = await mainArr.filter(
      (post) => post.slug === selectedHighlight
    );
    await setOpenMenu(findId[0]?.id);
  };
  useEffect(() => {
    GetInitialDropdownFunc();
  }, []);
  return (
    <div
      className={`pb-8 pt-2 ${
        isFooterVisible
          ? "When-Footer-Occured-HeightMiddle"
          : "When-Footer-Occured-HeightMiddle"
      } ${
        open ? "block p-2" : "hidden"
      } md:block overflow-auto
       ${
         darkTheme
           ? "scrollBar-dark-left bg-[#111]"
           : "scrollBarLeft bg-[#f7f9fc]"
       }
      `}
      // ${
      //   darkTheme ? "bg-LightBlack" : "bg-Border"
      // }
    >
      {/* <div className={``}> */}
      <div
        // onClick={() => collapseLeftBarFun()}
        className={`hidden md:block py-0 pr-2 self-end sticky top-0 z-30 cursor-pointer ${
          darkTheme ? "bg-[#111]" : "bg-[#eff3f8]"
        }`}
        // title={iconContentTitle}
      >
          {/* 7 Feb 2025 */}

        {/* <div className={`flex items-center justify-end`}>
          {leftBarHide === "block" && (
            <Tooltip
              title="Close table of contents"
              position="top"
              trigger="mouseenter"
              // theme={darkTheme ? "dark" : "light"}
              size="regular"
              delay={1000}
            >
              <div
                className={`transition-all rounded-xl p-1.5 ${
                  darkTheme
                    ? "hover:bg-bgCF active:bg-[#3786f5] hover:text-White"
                    : "hover:bg-bgCF active:bg-[#3786f5] hover:text-White"
                }`}
              >
                <IoIosArrowBack className={`w-5 h-5`} />
              </div>
            </Tooltip>
          )}
        </div> */}
      </div>
      {/* </div> */}
      {/* DYNAMIC DROPDOWN MENU  */}
      <div className={`text-[14px]`}>
        {allPosts
          .map((menu) => ({
            ...menu,
            posts: menu.posts?.filter((p) => p?.title?.trim()) ?? [],
          }))
          // Backend sometimes returns a category with no name and/or no
          // pages (e.g. an empty/draft section) -- rendering it leaves a
          // blank clickable header with nothing underneath, which reads as
          // unexplained empty space in the sidebar.
          .filter((menu) => menu?.name?.trim() && menu.posts.length > 0)
          .map((menu, index) => {
            const isActiveCategory = menu.posts?.some(
              (p) => p.slug === selectedHighlight
            );
            return (
            <div key={index} className={`${index > 0 ? "mt-3" : ""}`}>
              <div
                onClick={() => toggleCategory(menu.name)}
                className={`line-clamp-2 py-1.5 px-2 rounded-lg w-full text-left flex items-center gap-1.5 cursor-pointer text-[12px] font-bold uppercase tracking-wider transition-colors duration-150 ${
                  darkTheme
                    ? "text-[#9aa4b2] hover:bg-White/[0.06] hover:text-White"
                    : "text-[#4a5568] hover:bg-White hover:shadow-sm hover:text-Text"
                }`}
              >
                {menu?.posts?.length > 0 && (
                  <MdKeyboardArrowRight
                    className={`w-4 h-4 shrink-0 transition-transform duration-200 ${
                      collapsedCategories[menu.name] ? "" : "rotate-90"
                    }`}
                  />
                )}
                <div className="line-clamp-3 flex-1">{menu.name}</div>
              </div>
              <AnimatePresence>
                {!collapsedCategories[menu.name] && menu.posts.length > 0 && (
                  <motion.ul
                    initial="closed"
                    animate="open"
                    exit="closed"
                    variants={dropdownVariants}
                    className={`pageHeadingOnRight pl-3 ml-3 mt-0 space-y-[1px] border-l transition-colors duration-200 ${
                      isActiveCategory
                        ? darkTheme
                          ? "border-l-bgCF/50"
                          : "border-l-cfBlue/40"
                        : darkTheme
                          ? "border-l-[#2a2a2a]"
                          : "border-l-[#e3e8ef]"
                    }`}
                  >
                    {menu.posts.map((item, itemIndex) => {
                      const isActive = selectedHighlight === item.slug;
                      return (
                        <motion.li
                          variants={itemVariants}
                          key={itemIndex}
                          className="relative"
                        >
                          {isActive && (
                            <span
                              className={`absolute -left-[13px] top-1/2 -translate-y-1/2 h-4 w-[3px] rounded-full ${
                                darkTheme ? "bg-bgCF" : "bg-cfBlue"
                              }`}
                            />
                          )}
                          <div className={`line-clamp-2`}>
                            <div
                              className={`group flex items-center justify-between gap-1 transition-all duration-150 rounded-lg py-1.5 px-3 cursor-pointer text-[13.5px] leading-snug ${
                                isActive
                                  ? darkTheme
                                    ? "bg-bgCF text-White font-normal shadow-sm"
                                    : "bg-cfBlue text-White font-normal shadow-sm"
                                  : darkTheme
                                    ? "text-[#bebebe] hover:bg-White/[0.06] hover:text-White hover:translate-x-[2px]"
                                    : "text-[#6e6e6e] hover:bg-White hover:shadow-sm hover:text-Text hover:translate-x-[2px]"
                              }`}
                              onClick={() => {
                                subToggleDropdown(
                                  item.title,
                                  item,
                                  itemIndex,
                                  menu.name
                                );
                                if (isActive && headings?.length > 0) {
                                  setIsOutlineOpen((o) => !o);
                                }
                              }}
                            >
                              <div className="line-clamp-2 flex-1">
                                {item.title}
                              </div>
                              {isActive && headings?.length > 0 && (
                                <MdKeyboardArrowRight
                                  className={`w-4 h-4 shrink-0 transition-transform duration-200 ${
                                    isOutlineOpen ? "rotate-90" : ""
                                  }`}
                                />
                              )}
                            </div>
                          </div>
                          {isActive && headings?.length > 0 && (
                            <AnimatePresence>
                              {isOutlineOpen && (
                                <motion.div
                                  initial="closed"
                                  animate="open"
                                  exit="closed"
                                  variants={dropdownVariants}
                                  className={`mt-[1px] overflow-hidden text-[13px] ${
                                    darkTheme ? "text-[#9aa4b2]" : "text-[#6e6e6e]"
                                  }`}
                                >
                                  {SidebarMenu}
                                </motion.div>
                              )}
                            </AnimatePresence>
                          )}
                        </motion.li>
                      );
                    })}
                  </motion.ul>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </div>
  );
}
